var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistorySwap = function SvgHistorySwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M13.998 9.43H1.57a.143.143 0 0 0-.143.142v1.071c0 .079.064.143.143.143h10.807L9.8 14.054a.144.144 0 0 0 .113.232h1.294c.088 0 .17-.039.225-.109l3.015-3.823a.572.572 0 0 0-.45-.925m.43-4.215H3.62l2.577-3.268a.144.144 0 0 0-.113-.232H4.79c-.087 0-.17.04-.225.109L1.551 5.647A.571.571 0 0 0 2 6.572h12.429a.143.143 0 0 0 .143-.143V5.358a.143.143 0 0 0-.143-.143"
  })));
};
export default SvgHistorySwap;